<template>
  <v-form v-model="formValid" ref="property">
    <v-container fluid class="pa-2">
      <v-app-bar flat dense color="primary" class="darken-2">
        <v-toolbar-title class="subheading">{{
          properties._id ? $t("checklistapi.props.updateProps") : $t("checklistapi.props.addProps")
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" fab small dark @click="closeDialogHandler">
          <v-icon>close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-row>
        <v-col cols="12" md="3">
          <v-autocomplete
            outlined
            clearable
            hide-details
            :items="$dd_property_types()"
            v-model="properties.type"
            :rules="$_requiredValidation"
            item-text="text"
            item-value="key"
            :no-data-text="$t('global.no_data_available')"
            autocomplete="new-password"
            :label="$t('checklistapi.props.type')"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="2">
          <v-checkbox label="Is Active" v-model="properties.is_active"></v-checkbox>
        </v-col>
        <v-col cols="12">
          <v-card class="pa-0" :loading="loadingProp">
            <v-app-bar flat dense color="secondary">
              <v-toolbar-title class="subheading">{{ $t("checklistapi.props.formAttributes") }}</v-toolbar-title>
            </v-app-bar>
            <v-divider></v-divider>
            <v-card-text class="pa-1" v-if="isTypeSelected">
              <v-form ref="fieldsForm">
                <v-container fluid class="pa-0">
                  <v-row v-if="![10, 12, 19].includes(properties.type)">
                    <v-col cols="12" md="3">
                      <v-text-field
                        autocomplete="new-password"
                        outlined
                        hide-details
                        :label="$t('checklistapi.props.name')"
                        v-model="properties.name"
                        required
                        :rules="properties.name ? fieldAndUniqueValidation : $_requiredValidation"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3" v-if="properties.type !== 16">
                      <v-text-field
                        autocomplete="new-password"
                        outlined
                        hide-details
                        :label="$t('checklistapi.props.label')"
                        v-model="properties.label"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2" v-if="properties.type === 1">
                      <v-checkbox :label="$t('checklistapi.props.useAsTitle')" v-model="useAsTitle" hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" md="3" v-if="![19].includes(properties.type)">
                      <v-text-field
                        autocomplete="new-password"
                        type="number"
                        outlined
                        hide-details
                        :label="$t('checklistapi.props.columns')"
                        v-model="properties.columns"
                        required
                        :rules="columnValidation"
                      ></v-text-field>
                    </v-col>
                    <template v-if="properties.type === 15">
                      <v-col md="3" cols="0"></v-col>
                      <v-col cols="12" md="3">
                        <label>{{ $t("checklistapi.props.fontSize") }}</label>
                        <v-slider
                          v-model="properties.font_size"
                          :tick-labels="fontLabels"
                          :max="3"
                          :step="0.5"
                          :min="0.5"
                          ticks="always"
                          tick-size="5"
                        ></v-slider>
                      </v-col>
                      <v-col cols="12" md="3">
                        <label>{{ $t("checklistapi.props.preview") }}:</label>
                        <br /><br />
                        <span class="pa-0 subtitle-2" :style="{ fontSize: `${properties.font_size}em !important` }">{{
                          properties.label
                        }}</span>
                      </v-col>
                    </template>
                    <template v-if="properties.type === 16">
                      <v-col md="6" cols="0"></v-col>
                      <v-col cols="12" md="6">
                        <label>{{ $t("checklistapi.props.link") }}</label>
                        <v-textarea outlined auto-grow dense hide-details v-model="properties.html_content"></v-textarea>
                      </v-col>
                      <v-col cols="12" md="6">
                        <label>{{ $t("checklistapi.props.preview") }}</label>
                        <br /><br />
                        <div v-html="properties.html_content"></div>
                      </v-col>
                    </template>
                    <v-col
                      cols="12"
                      md="3"
                      v-if="
                        properties.type !== 11 &&
                        properties.type !== 13 &&
                        properties.type !== 14 &&
                        properties.type !== 15 &&
                        properties.type !== 16
                      "
                    >
                      <v-autocomplete
                        autocomplete="new-password"
                        :no-data-text="$t('global.no_data_available')"
                        outlined
                        :items="validationList"
                        v-model="properties.validation"
                        clearable
                        @click:clear="properties.validation = null"
                        hide-details
                        item-text="text"
                        item-value="value"
                        :label="$t('checklistapi.props.validation')"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      v-if="
                        properties.type !== 11 &&
                        properties.type !== 13 &&
                        properties.type !== 14 &&
                        properties.type !== 15 &&
                        properties.type !== 16
                      "
                    >
                      <v-text-field
                        autocomplete="new-password"
                        outlined
                        hide-details
                        :label="$t('checklistapi.props.placeholder')"
                        v-model="properties.placeholder"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2" v-if="properties.type === 5">
                      <v-checkbox :label="$t('checklistapi.props.isMultiSelect')" v-model="isMultiSelect" hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" md="3" v-if="![3, 9, 11, 13, 14].includes(properties.type)">
                      <!--checkbox, file, signature, divider and panel types are needed this col so hide it   properties.type !== 3 && properties.type !== 9  && properties.type !== 11 && properties.type !== 13 && properties.type !== 14   // condition added by Mr.Vinoth -->
                      <v-text-field
                        autocomplete="new-password"
                        outlined
                        :label="$t('checklistapi.props.defaultValue')"
                        v-model="properties.default_value"
                        :hide-details="properties.type !== 5 && properties.type !== 4"
                        persistent-hint
                        :hint="properties.type === 5 || properties.type === 4 ? $t('checklistapi.props.enterValue') : ''"
                        v-if="properties.type === 1 || properties.type === 5 || properties.type === 4"
                        required
                      ></v-text-field>
                      <v-textarea
                        outlined
                        hide-details
                        :label="$t('checklistapi.props.defaultValue')"
                        v-model="properties.default_value"
                        v-else-if="properties.type === 2"
                      ></v-textarea>
                      <v-menu v-model="dateMenu" :close-on-content-click="false" max-width="290" v-else-if="properties.type === 6">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            autocomplete="new-password"
                            outlined
                            hide-details
                            v-model="properties.default_value"
                            clearable
                            prepend-icon="mdi-calendar"
                            :label="$t('checklistapi.props.defaultValue')"
                            readonly
                            v-on="on"
                            @click:clear=";(properties.default_value = null), (datePicker = null)"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :locale="$locale_bcp47()"
                          v-model="datePicker"
                          @change="dateMenu = false"
                          color="primary darken-2"
                          header-color="primary"
                        ></v-date-picker>
                      </v-menu>
                      <v-menu
                        ref="timeMenu"
                        v-model="timeMenu"
                        v-else-if="properties.type === 7"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        :return-value.sync="time"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            autocomplete="new-password"
                            outlined
                            hide-details
                            v-model="properties.default_value"
                            :label="$t('checklistapi.props.defaultValue')"
                            prepend-icon="mdi-timer"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="timeMenu"
                          v-model="properties.default_value"
                          format="24hr"
                          full-width
                          @click:minute="$refs.timeMenu.save(properties.default_value)"
                        ></v-time-picker>
                      </v-menu>
                      <v-switch
                        inset
                        :label="$t('checklistapi.props.defaultValue')"
                        v-model="properties.default_value"
                        hide-details
                        v-else-if="properties.type === 8"
                      ></v-switch>
                    </v-col>
                    <v-col cols="12" md="2" v-if="properties.type === 5">
                      <v-checkbox :label="$t('checklistapi.props.isApi')" v-model="isAPI" hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" md="2" v-if="payload.from === 'properties' && properties.type !== 15 && properties.type !== 16">
                      <v-checkbox :label="$t('checklistapi.props.favourite')" v-model="properties.favourite" hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" v-if="properties.type === 3">
                      <options-list :list="listOfCheckbox" ref="optionslistComponent"></options-list>
                    </v-col>
                    <v-col cols="12" v-if="properties.type === 4">
                      <options-list :list="listOfRadios" ref="optionslistComponent"></options-list>
                    </v-col>
                    <v-col cols="12" v-if="properties.type === 5 && !isAPI">
                      <options-list :list="listOfOptions" ref="optionslistComponent"></options-list>
                    </v-col>
                    <v-col cols="12" v-if="[20, 22, 23, 24, 25].includes(properties.type)">
                      <options-list :list="listOfSubItems" ref="optionslistComponent" :type="properties.type"></options-list>
                    </v-col>
                    <v-col cols="12" v-if="properties.type === 5 && isAPI">
                      <v-container fluid class="pa-0">
                        <v-row>
                          <v-col cols="12" md="6" lg="4"
                            ><v-text-field
                              autocomplete="new-password"
                              outlined
                              hide-details
                              :label="$t('checklistapi.props.apiUrl')"
                              required
                              v-model="apiOptions.apiUrl"
                            ></v-text-field
                          ></v-col>
                          <v-col cols="12" md="6" lg="3"
                            ><v-text-field
                              autocomplete="new-password"
                              outlined
                              hide-details
                              :label="$t('checklistapi.props.objectName')"
                              required
                              v-model="apiOptions.objectName"
                            ></v-text-field
                          ></v-col>
                          <v-col cols="12" md="6" lg="3"
                            ><v-text-field
                              autocomplete="new-password"
                              outlined
                              hide-details
                              :label="$t('checklistapi.props.name')"
                              required
                              v-model="apiOptions.name"
                            ></v-text-field
                          ></v-col>
                        </v-row>
                      </v-container>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col cols="12" md="3">
                      <v-text-field
                        autocomplete="new-password"
                        outlined
                        hide-details
                        v-model="properties.name"
                        :label="$t('checklistapi.props.name')"
                        :rules="properties.name ? fieldAndUniqueValidation : $_requiredValidation"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" :md="properties.type === 12 ? '3' : '6'">
                      <v-text-field
                        autocomplete="new-password"
                        outlined
                        hide-details
                        :type="properties.type === 12 ? 'number' : 'text'"
                        v-model="properties.label"
                        :label="properties.type === 12 ? $t('checklistapi.props.gridColumns') : $t('checklistapi.props.question')"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3" v-if="![18, 19].includes(properties.type)">
                      <v-text-field
                        autocomplete="new-password"
                        type="number"
                        outlined
                        hide-details
                        :label="$t('checklistapi.props.columns')"
                        v-model="properties.columns"
                        required
                        :rules="columnValidation"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-textarea outlined hide-details :label="$t('checklistapi.props.link')" v-model="properties.html"></v-textarea>
                    </v-col>
                    <template v-if="properties.type === 19">
                      <v-layout wrap class="col-6">
                        <v-checkbox
                          class="mx-2 my-auto"
                          :label="$t('checklistapi.form.signature')"
                          v-model="checkboxFlags.signature"
                          hide-details
                        ></v-checkbox>
                        <v-checkbox
                          class="mx-2 my-auto"
                          :label="$t('checklistapi.form.date')"
                          v-model="checkboxFlags.date"
                          hide-details
                        ></v-checkbox>
                        <v-checkbox
                          class="mx-2 my-auto"
                          :label="$t('checklistapi.props.hideComments')"
                          v-model="hideComments"
                          hide-details
                        ></v-checkbox>
                        <v-checkbox
                          class="mx-2 my-auto"
                          :label="$t('checklistapi.props.hideAttachments')"
                          v-model="hideAttachments"
                          hide-details
                        ></v-checkbox>
                        <!-- <v-checkbox class="mx-2 my-auto" :label="$t('checklistapi.form.notes')" v-model="checkboxFlags.notes" hide-details></v-checkbox> -->
                      </v-layout>
                    </template>
                    <v-col cols="12" lg="3" md="4" sm="6" xs="12" v-if="[10, 19].includes(properties.type)">
                      <label><strong>Knapptype:</strong></label
                      ><br /><!-- Answer select type: -->
                      <v-btn-toggle
                        dense
                        v-model="surveyOptions.selectionType"
                        mandatory
                        @change="surveyDefaultValues.answer = surveyOptions.selectionType === 0 ? '' : []"
                      >
                        <v-btn color="primary">
                          <v-icon color="white" dark>mdi-radiobox-marked</v-icon> Radio
                          <v-icon size="20" class="ml-1" v-if="surveyOptions.selectionType === 0" color="white" dark>mdi-check</v-icon>
                        </v-btn>
                        <v-btn color="primary">
                          <!-- Checkbox --><v-icon color="white" dark>mdi-checkbox-marked</v-icon> Avmerkningsboks
                          <v-icon size="20" class="ml-1" v-if="surveyOptions.selectionType === 1" color="white" dark>mdi-check</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                    </v-col>
                    <template v-if="[10, 19].includes(properties.type)">
                      <v-col cols="12" class="py-0">
                        <v-card class="pa-1">
                          <v-app-bar flat dense color="secondary">
                            <v-toolbar-title class="subheading">{{ $t("checklistapi.props.defaultValue") }}</v-toolbar-title>
                          </v-app-bar>
                          <v-divider class="ma-0"></v-divider>
                          <v-card-text class="pa-0">
                            <v-row class="mx-0">
                              <v-col lg="3" md="4" sm="6">
                                <h5 class="mb-2">Answer to select</h5>
                                <!-- <v-text-field autocomplete="new-password" v-if="surveyOptions.selectionType === 0" dense outlined v-model="surveyDefaultValues.answer" hide-details></v-text-field> -->
                                <v-select
                                  hide-details
                                  :multiple="surveyOptions.selectionType === 1"
                                  dense
                                  outlined
                                  v-model="surveyDefaultValues.answer"
                                  :items="listOfAnswerOptions.map((x) => x.value)"
                                  clearable
                                  hide-details
                                  item-text="text"
                                  item-value="keyword"
                                  :label="$t('checklistapi.props.defaultValueKeyword')"
                                ></v-select>
                                <!-- v-else-if="surveyOptions.selectionType === 1" -->
                              </v-col>
                              <v-col lg="3" md="4" sm="6" v-if="properties.type === 19 && checkboxFlags.date">
                                <h5 class="mb-2">Date</h5>
                                <v-select
                                  hide-details
                                  dense
                                  outlined
                                  v-model="surveyDefaultValues.dateDefaultValueKeyword"
                                  :items="this.dateKeywordList"
                                  clearable
                                  hide-details
                                  item-text="text"
                                  item-value="keyword"
                                  :label="$t('checklistapi.props.defaultValueKeyword')"
                                ></v-select>
                              </v-col>
                              <v-col lg="3" md="4" sm="6" v-if="properties.type === 19 && checkboxFlags.signature">
                                <h5 class="mb-2">Signature</h5>
                                <v-text-field
                                  autocomplete="new-password"
                                  hide-details
                                  dense
                                  outlined
                                  v-model="surveyDefaultValues.signature"
                                  hide-details
                                ></v-text-field>
                              </v-col>
                              <v-col lg="3" md="4" sm="6" v-if="!hideComments">
                                <h5 class="mb-2">Comments</h5>
                                <v-textarea
                                  hide-details
                                  outlined
                                  rows="3"
                                  auto-grow
                                  dense
                                  hide-details
                                  v-model="surveyDefaultValues.comments"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </template>
                    <v-col cols="12" v-if="[10, 19].includes(properties.type)">
                      <options-list :list="listOfAnswerOptions" ref="optionslistComponent" :type="properties.type"></options-list>
                    </v-col>
                  </v-row>
                  <v-row v-if="properties.type === 12 && properties.label">
                    <v-col cols="12" class="pt-0 pb-1">
                      <h5>{{ $t("checklistapi.props.enterTitleOfColumn") }}:</h5>
                      <div v-if="loadingGrids">
                        <h4>{{ $t("checklistapi.props.loadingGrid") }}</h4>
                        <v-progress-linear color="primary accent-4" indeterminate rounded height="6"></v-progress-linear>
                      </div>
                    </v-col>
                    <v-col cols="12" class="pt-0" v-if="!loadingGrids">
                      <v-card class="d-flex align-content-start flex-wrap pa-0 avalia_form_grid" flat tile>
                        <v-card max-width="80" v-for="(grid, index) in listOfGridLabel" :key="index" class="pa-0" outlined tile>
                          <v-text-field
                            autocomplete="new-password"
                            single-line
                            dense
                            full-width
                            v-model="grid.label"
                            outlined
                            hide-details
                          ></v-text-field>
                        </v-card>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-card-actions>
        <v-layout justify-center>
          <template v-if="payload.isStandard || payload.isAdvanced">
            <v-btn color="success test" :loading="loading" @click="updateInForm()" dark v-if="payload.from === 'forms'">{{
              $t("checklistapi.app.update")
            }}</v-btn>
          </template>
          <template v-else>
            <v-btn color="success test" :loading="loading" @click="updateInForm()" dark v-if="payload.from === 'forms' && payload.propid">{{
              $t("checklistapi.app.update")
            }}</v-btn>
            <v-btn
              color="success test"
              :loading="loading"
              @click="updateInForm()"
              dark
              v-else-if="payload.from === 'forms' && !payload.propid"
              >{{ $t("checklistapi.app.save") }}</v-btn
            >
            <v-btn
              color="success test"
              :loading="loading"
              @click="saveUpdateHandler('SAVE')"
              dark
              v-else-if="!payload.propid"
              class="mr-2"
              :disabled="$hasExtraModule('checklist') != 'active'"
              >{{ properties._id ? $t("checklistapi.app.update") : $t("checklistapi.app.save") }}</v-btn
            >
          </template>
          <v-btn
            color="info"
            v-if="properties._id && payload.from === 'properties'"
            :loading="loading"
            @click="saveUpdateHandler('UPDATE_CLOSE')"
            dark
            :disabled="$hasExtraModule('checklist') != 'active'"
            >{{ $t("checklistapi.app.updateClose") }}</v-btn
          >
        </v-layout>
      </v-card-actions>
      <v-card v-if="propertyGroupedByType && propertyGroupedByType.length > 0">
        <v-app-bar flat dense color="secondary" class="ma-0 pa-0">
          <v-toolbar-title class="subheading">{{ $t("checklistapi.props.customProperties") }}</v-toolbar-title>
        </v-app-bar>
        <v-divider></v-divider>
        <v-card-text>
          <template v-for="(item, index) in listOfTypes">
            <v-chip label small class="mt-1 mr-3" color="primary" :key="index" @click="loadFieldValues(item)"> {{ item.name }} </v-chip>
          </template>
        </v-card-text>
      </v-card>
    </v-container>
  </v-form>
</template>
<script>
/* eslint-disable */
import { listOfFormTypes } from "@/utils/support_list"
import { checklistApi } from "@/plugins/api_settings"
import surveyAndAdvancedSurvey from "@/mixins/survey_and_advanced_survey"
export default {
  mixins: [surveyAndAdvancedSurvey],
  props: ["payload", "properties", "token", "propertyGroupedByType", "propertyNames"],
  data() {
    return {
      formValid: false,
      isTypeSelected: false,
      date: null,
      dateMenu: false,
      timeMenu: false,
      time: null,
      datePicker: null,
      validationList: [
        { text: "Required", value: "required" },
        { text: "Email", value: "email" }
      ],
      listOfOptions: [{}],
      listOfRadios: [{}],
      listOfCheckbox: [{}],
      listOfSubItems: [{}],
      isMultiSelect: false,
      useAsTitle: false,
      panelId: 0,
      isAPI: false,
      loading: false,
      apiOptions: {},
      listOfFormTypes: listOfFormTypes.sort((a, b) => a.text.localeCompare(b.text)),
      loadingGrids: false,
      listOfGridLabel: [],
      preGridList: [],
      gridCount: 0,
      gridHasData: false,
      listOfTypes: [],
      listOfHeaderLabel: [],
      listOfGridData: [],
      preGridLabelList: [],
      preGridDataValue: [],
      listOfGridColumn: [],
      fontLabels: ["0.5", "1", "1.5", "2", "2.5", "3"],
      loadingProp: false,
      hideComments: false,
      hideAttachments: false,
      listOfAnswerOptions: [
        { label: "Yes", value: "yes", isactive: true },
        { label: "No", value: "no", isactive: true },
        { label: "Not Applicable", value: "not_applicable", isactive: true }
      ],
      /* Advanced Survey component */
      checkboxFlags: { signature: true, date: true, notes: true },
      isWidthAboveHeader: false,
      checkboxProperties: {
        view: "default" // horizontal, vertical, default
      },
      checkboxViews: [
        { text: "Default", value: "default" },
        { text: "Horizontal", value: "horizontal" },
        { text: "Vertical", value: "vertical" }
      ],
      /* --- */
      dateKeywordList: [{ text: "CURDATE", keyword: "CURDATE" }],
      timeKeywordList: [{ text: "CURTIME", keyword: "CURTIME" }],
      defaultValueKeyword: "",
      gridFieldHasPropertyForm: false,
      datagridEditTab: 0,
      dataGridAvailableFields: [],
      dataGridNameEditInput: null,
      rerendertab: 0,
      surveyDefaultValues: {
        dateDefaultValueKeyword: "",
        signature: "",
        comments: "",
        answer: null
      },
      /* survey & advanced survey selection type */
      surveyOptions: { selectionType: 0 },
      selectType: "default",
      listOfAvailableFields: [],
      surveyConditionScripts: [],
      surveyLogicScripts: {},
      hintFor_hasTheVal: null
    }
  },
  watch: {
    datePicker(val) {
      if (val) {
        this.properties.default_value = this.$format.formatDate(val, "YYYY-MM-DD", "DD.MM.YYYY")
      }
    },
    "properties.type"(val) {
      if ([18, 19].includes(val)) this.properties.columns = 12
      if (val && this.propertyGroupedByType) {
        let customProperties = this.propertyGroupedByType.filter((x) => x.type === val)
        this.listOfTypes = customProperties
        this.isTypeSelected = true
      }
      if (val) this.isTypeSelected = true
      else this.isTypeSelected = false
      if (this.$refs.fieldsForm) this.$refs.fieldsForm.reset()
      if (!this.properties._id) {
        this.listOfOptions = [{}]
        this.checkboxFlags.signature = false
        this.checkboxFlags.date = false
      }
    },
    "properties.label"(val) {
      if (val && this.properties.type === 12) {
        this.loadingGrids = true
        this.debouncedGetGrid()
      }
    }
  },
  components: {
    OptionsList: () => import("../property/OptionsList")
  },
  computed: {
    fieldAndUniqueValidation() {
      return [
        (v) => (v ? /^[a-zA-Z0-9_]*$/.test(v) || "Invalid name" : true),
        (v) => (v && this.propertyNames ? !this.propertyNames.includes(v) || "Name property exists" : true)
      ]
    },
    columnValidation() {
      return [(v) => !!v || "required", (v) => (v <= 12 && v >= 1) || "enter columns b/w 1 to 12"]
    },
    fontSizeValidation() {
      return [(v) => !!v || "required", (v) => (v <= 3 && v >= 0.5) || "Invalid size"]
    }
  },
  mounted() {
    if (this.properties._id && !this.payload.propid) {
      this.getSingleRecordHandler(this.properties._id, "properties")
    }
    if (this.properties.id || this.payload.propid) {
      if (this.propertyNames) this.propertyNames.splice(this.propertyNames.indexOf(this.payload.name), 1) // For removing active property name from existing prop names
      let id = this.properties.id ? this.properties._id : this.payload.propid
      let type = this.payload.savedAlready ? "formproperties" : "properties"
      this.getSingleRecordHandler(id, type)
    } else if (this.payload.type) {
      this.$set(this.properties, "type", this.payload.type)
      if (this.propertyGroupedByType) {
        let customProperties = this.propertyGroupedByType.filter((x) => x.type === this.payload.type)
        this.listOfTypes = customProperties
      }
      this.isTypeSelected = true
    }

    if (!this.properties._id) {
      this.properties.is_active = true
    }

    this.properties.columns = this.payload.setColumns || 12
    this.properties.font_size = 1
    this.debouncedGetGrid = this.$format.debounce(this.getLoadedGrids, 500)
    this.debouncedGetComponent = this.$format.debounce(this.getLoadedComponent, 500)

    /* undefined issue dialog close after api calls done - show loader - emit event from parent to child */
    this.$eventBus.$on("showHideLoader", (loading) => {
      this.loading = loading
    })
  },
  methods: {
    handleRedirect() {
      if (this.payload.from === "properties") this.$router.push("/properties")
      else if (this.payload.from === "forms") this.$root.$emit("closeDialog")
    },
    loadFieldValues(item) {
      let url = `properties/${item._id}`
      checklistApi.get(url).then((result) => {
        if (result && result.data) {
          let model = this.$format.cloneVariable(result.data)
          model.validation = model.validation ? model.validation : null
          let values = model.default_value ? JSON.parse(model.default_value) : null
          if (values) {
            model = this.construtValues(values, model)
          }
          this.$emit("selected", model)
        }
      })
    },
    getSingleRecordHandler(id, type) {
      let url = type === "properties" ? `properties/${id}` : `formproperties/${id}`
      this.loadingProp = true
      checklistApi
        .get(url, this.token)
        .then((result) => {
          if (result && result.data) {
            let model = this.$format.cloneVariable(result.data)
            model.validation = model.validation ? model.validation : null
            let values = model.default_value ? JSON.parse(model.default_value) : null
            if (values) {
              model = this.construtValues(values, model)
            }
            model.name = this.payload.name ? this.payload.name : model.name
            /* set slno on update prop */
            model.slNo = this.payload.slNo
            this.$emit("selected", model)
            this.isTypeSelected = true
            this.loadingFields = false
          }
        })
        .catch((error) => {
          this.$handleServerSideError(error)
        })
        .then(() => {
          this.loadingProp = false
        })
    },
    construtValues(values, model) {
      switch (model.type) {
        case 1:
          this.useAsTitle = values.use_as_title
          model.default_value = values.default_value
          this.panelId = values.panelId
          break
        case 3:
          this.listOfCheckbox = values.options
          this.panelId = values.panelId
          break
        case 4:
          model.default_value = values.default_value
          this.listOfRadios = values.options
          this.panelId = values.panelId
          break
        case 20:
        case 22:
        case 23:
        case 24:
        case 25:
          model.default_value = values
          this.listOfSubItems = values.subitems
          break
        case 5:
          this.isMultiSelect = values.is_multiselect
          switch (values.isAPI) {
            case true:
              this.isAPI = values.isAPI
              this.apiOptions = { apiUrl: values.apiUrl, name: values.name, objectName: values.objectName }
              model.default_value = values.default_value
              break
            default:
              this.listOfOptions = values.options
              model.default_value = values.default_value
              break
          }
          this.panelId = values.panelId
          break
        case 12:
          this.listOfGridLabel = values.grid_data.labels
          this.preGridList = values.grid_data.labels
          this.gridCount = model.label
          this.gridHasData = true
          this.panelId = values.panelId
          break
        case 15:
          model.font_size = values.font_size
          break
        case 16:
          model.html_content = values.html_content
          break
        case 19:
          this.checkboxFlags = values.checkboxFlags || { signature: false, date: false, notes: false }
          this.hideAttachments = values.hideAttachments || false
          this.hideComments = values.hideComments || false
          model.default_value = values
          this.listOfAnswerOptions = values.options
          this.surveyOptions = values.surveyOptions || { selectionType: 0 }
          this.$set(this, "surveyDefaultValues", values.surveyDefaultValues || { answer: null })
          values.surveyConditionScripts && values.surveyConditionScripts.length
            ? this.$set(this, "surveyConditionScripts", values.surveyConditionScripts)
            : []
          this.addAnswerListToSurveyConditions()
          values.surveyLogicScripts
            ? this.$set(this, "surveyLogicScripts", this.surveyLogicScriptEncodeOrDecode(0, values.surveyLogicScripts))
            : {}
          this.panelId = values.panelId
          break
        default:
          model.default_value = values.default_value
          this.panelId = values.panelId
          break
      }
      return model
    },
    prepareFieldsWithData(data) {
      const model = this.$format.cloneVariable(data)
      model.validation = model.validation ? model.validation : null
      const isParsed = typeof model.default_value === "object" && model.default_value !== null
      let values = {}
      if (isParsed) values = model.default_value || null
      else values = JSON.parse(model.default_value)
      if (values) {
        switch (model.type) {
          case 1:
            this.useAsTitle = values.use_as_title
            model.default_value = values.default_value
            break
          case 3:
            this.listOfCheckbox = values.options
            break
          case 4:
            model.default_value = values.default_value
            this.listOfRadios = values.options
            break
          case 5:
            this.isMultiSelect = values.is_multiselect
            switch (values.isAPI) {
              case true:
                this.isAPI = values.isAPI
                this.apiOptions = { apiUrl: values.apiUrl, name: values.name, objectName: values.objectName }
                model.default_value = values.default_value
                break
              default:
                this.listOfOptions = values.options
                model.default_value = values.default_value
                break
            }
            break
          case 12:
            this.listOfGridLabel = values.grid_data.labels
            this.preGridList = values.grid_data.labels
            this.gridCount = model.label
            this.gridHasData = true
            break
          default:
            model.default_value = values.default_value
            break
        }
      }
      model.name = this.payload.name ? this.payload.name : model.name
      return model
    },
    addAnswerListToSurveyConditions() {
      // const selectedValues = this.surveyConditionScripts.map(x => x.answer_value)
      if (this.surveyConditionScripts.length === 0) this.addNewLineAnswerCondition()
      else {
        this.surveyConditionScripts.forEach((el) => {
          el.answersList = this.listOfAnswerOptions // [this.listOfAnswerOptions.find(y => y.value === el.answer_value)] // this.getEachLineAnswersList(selectedValues, x)
        })
      }
    },
    removeAnswerListFromSurveyConditions() {
      let list = this.$format.cloneVariable(this.surveyConditionScripts)
      if (list && list.length) {
        list.forEach((x) => {
          delete x.answersList
        })
      } else list = []
      return list
    },
    saveUpdateHandler(type) {
      if (
        ([3, 4, 5, 10, 19].includes(this.properties.type) ? this.$refs.optionslistComponent.$refs.optionsList.validate() : true) &&
        this.$refs.fieldsForm &&
        this.$refs.fieldsForm.validate()
      ) {
        this.loading = true
        let model = this.$format.cloneVariable(this.properties)
        model = { ...model }
        model.validation = model.validation || null
        model = this.constructDefaultValue(model, false)
        let url = this.payload.from === "properties" ? "properties" : "formproperties"
        const method = model._id ? "put" : "post"
        url = model._id ? `${url}/${model._id}` : url
        checklistApi[method](url, model, this.token)
          .then((response) => {
            this.$emit("update", { data: response, status: "success", type, action: model._id ? "update" : "add" })
          })
          .catch((error) => {
            this.$emit("update", { data: error, status: "error", type })
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$awn.alert(this.$t("checklistapi.app.validationFailed"))
    },
    updateInForm() {
      if (
        ([3, 4, 5, 10, 19].includes(this.properties.type) ? this.$refs.optionslistComponent.$refs.optionsList.validate() : true) &&
        this.$refs.fieldsForm &&
        this.$refs.fieldsForm.validate()
      ) {
        let model = this.$format.cloneVariable(this.properties)
        model = this.constructDefaultValue(model, true)
        this.$root.$emit("updateProperty", { model: model, update: this.payload.savedAlready })
      } else {
        this.$awn.alert(this.$t("checklistapi.app.validationFailed"))
      }
    },
    constructDefaultValue(model, form) {
      let panelId = model.panelid || this.panelId || 0
      let panelObj = {}
      let fieldObj = {}
      switch (model.type) {
        case 1:
          model.default_value = form
            ? { default_value: model.default_value, use_as_title: this.useAsTitle, panelId }
            : JSON.stringify({ default_value: model.default_value, use_as_title: this.useAsTitle, panelId })
          return model
        case 3:
          model.default_value = form ? { options: this.listOfCheckbox, panelId } : JSON.stringify({ options: this.listOfCheckbox, panelId })
          return model
        case 4:
          model.default_value = form
            ? { default_value: model.default_value, options: this.listOfRadios, panelId }
            : JSON.stringify({ default_value: model.default_value, options: this.listOfRadios, panelId })
          return model
        case 20:
        case 22:
        case 23:
        case 24:
        case 25:
          fieldObj = Object.assign(panelObj, { subitems: this.listOfSubItems })
          if (model.default_value && model.default_value.slNo) fieldObj.slNo = model.default_value.slNo
          model.default_value = form ? fieldObj : JSON.stringify(fieldObj)
          return model
        case 5:
          switch (this.isAPI) {
            case true:
              model.default_value = form
                ? { default_value: model.default_value, is_multiselect: this.isMultiSelect, isAPI: this.isAPI, ...this.apiOptions, panelId }
                : JSON.stringify({
                    default_value: model.default_value,
                    is_multiselect: this.isMultiSelect,
                    isAPI: this.isAPI,
                    ...this.apiOptions,
                    panelId
                  })
              return model
            case false:
              model.default_value = form
                ? { default_value: model.default_value, is_multiselect: this.isMultiSelect, options: this.listOfOptions, panelId }
                : JSON.stringify({
                    default_value: model.default_value,
                    is_multiselect: this.isMultiSelect,
                    options: this.listOfOptions,
                    panelId
                  })
              return model
          }
          break
        case 12:
          model.default_value = form
            ? { grid_data: { labels: [...this.listOfGridLabel], data: {} }, panelId }
            : JSON.stringify({ grid_data: { labels: [...this.listOfGridLabel], data: {} }, panelId })
          return model
        case 15:
          model.default_value = form
            ? { font_size: this.properties.font_size, panelId }
            : JSON.stringify({ font_size: this.properties.font_size, panelId })
          return model
        case 16:
          fieldObj = Object.assign(panelObj, { html_content: this.properties.html_content })
          model.default_value = form ? fieldObj : JSON.stringify(fieldObj)
          return model
        case 19:
          const surveyConditionScripts = this.removeAnswerListFromSurveyConditions()
          const surveyLogicScripts = this.surveyLogicScriptEncodeOrDecode(1)
          fieldObj = {
            ...panelObj,
            ...{
              hideComments: this.hideComments,
              hideAttachments: this.hideAttachments,
              checkboxFlags: this.checkboxFlags,
              surveyOptions: this.surveyOptions,
              surveyDefaultValues: this.surveyDefaultValues,
              surveyConditionScripts: surveyConditionScripts,
              surveyLogicScripts: surveyLogicScripts,
              options: this.listOfAnswerOptions
            }
          }
          model.default_value = form ? fieldObj : JSON.stringify(fieldObj)
          return model
          return model
        default:
          model.default_value = form
            ? { default_value: model.default_value, panelId }
            : JSON.stringify({ default_value: model.default_value, panelId })
          return model
      }
    },
    getLoadedGrids() {
      let grids = isNaN(this.properties.label) ? 0 : this.properties.label
      let gridList = this.gridHasData ? this.$format.cloneVariable(this.preGridList) : []
      if (this.gridHasData) {
        let addExtra = grids - +this.gridCount
        if (addExtra > 0) {
          for (let i = 0; i < addExtra; i++) {
            gridList.push({ label: "" })
          }
        } else {
          gridList.splice(grids, Math.abs(grids - gridList.length))
        }
      } else {
        for (let i = 0; i < grids; i++) {
          gridList.push({ label: "" })
        }
      }
      this.listOfGridLabel = gridList
      this.loadingGrids = false
    },
    getLoadedComponent() {
      const grids = isNaN(this.properties.columns) ? 0 : this.properties.columns
      const gridList = this.gridHasData ? this.$format.cloneVariable(this.preGridLabelList) : []
      if (this.gridHasData) {
        if (gridList.length < parseInt(grids)) {
          for (let i = gridList.length; i < parseInt(grids); i++) {
            gridList.push({ label: "" })
          }
        } else {
          gridList.splice(grids, Math.abs(grids - gridList.length))
        }
      } else {
        for (let i = 0; i < grids; i++) {
          gridList.push({ label: "" })
        }
      }
      this.listOfGridLabel = gridList
      const columns = isNaN(this.properties.rows) ? 0 : this.properties.rows
      const columnsList = this.gridHasData ? this.$format.cloneVariable(this.preGridDataValue) : []
      if (this.gridHasData) {
        if (columnsList.length < parseInt(columns)) {
          for (let i = columnsList.length; i < parseInt(columns); i++) {
            const item = { name: `${i + 1}. `, [`compValue_${i}`]: "", [`compSelect_${i}`]: "" }
            columnsList.push(item)
          }
        } else {
          columnsList.splice(columns, Math.abs(columns - columnsList.length))
        }
      } else {
        for (let i = 0; i < columns; i++) {
          let item = { name: `${i + 1}. ` }
          for (let j = 0; j < columns; j++) {
            item = { ...item, [`compValue_${j}`]: "", [`compSelect_${j}`]: "" }
          }
          columnsList.push(item)
        }
      }
      this.listOfGridColumn = columnsList
      this.loadingGrids = false
    },
    closeDialogHandler() {
      this.$refs.property.reset()
      this.$emit("closeForm")
    },
    addNewLineAnswerCondition() {
      let list = this.listOfAnswerOptions || []
      list = list.filter((x) => x.isactive && !this.surveyConditionScripts.map((x) => x.answer_value).includes(x.value))
      this.surveyConditionScripts.push({ answersList: list })
    }
  },
  beforeDestroy() {
    this.$eventBus.$off("showHideLoader")
  }
}
</script>
